// The line across the top of a guest's screen while they connect or wait to be
// let in. The call screen and the owner's waiting room preview both draw it
// from here, so the preview shows exactly what a guest sees.

import type { JSX } from "react";

export function waitingText(hostName: string | null | undefined): string {
  return hostName ? `Waiting for ${hostName} to let you in.` : "Waiting to be let in.";
}

export function WaitingLine({ text }: { readonly text: string }): JSX.Element {
  // Placed by .waitline in global.css: across the top on a phone, above the
  // mic, camera, and hang up buttons on a wider screen (QUEUE rows 427, 432).
  return (
    <div role="status" className="waitline">
      <span className="callspin" aria-hidden="true" />
      {text}
    </div>
  );
}
